import React from "react";
import { Box, Checkbox, Count, Label, Typography } from "@bca/ui-library";
import styled from "styled-components";

const MulticolourCircle = styled(Box)`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: conic-gradient(
    from 90deg,
    violet,
    indigo,
    blue,
    green,
    yellow,
    orange,
    red,
    violet
  );
`;

const UnknownCircle = styled(Box)`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: linear-gradient(90deg, #fff 50%, #000 0) 5px,
    linear-gradient(#fff 50%, #000 0) 1px 1px;
  background-blend-mode: exclusion;
  background-size: 8px 8px;
`;

const WhiteCircle = styled(Box)`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  background-size: 8px 8px;
  border: 1px solid #bebfbe;
`;

const CheckboxWithBadge = ({
  filterKey,
  count,
  iconColor,
  iconText,
  onChange,
  isSelected,
}) => {
  const viewport = window.innerWidth;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      maxWidth={viewport}
      my={3}
    >
      <Checkbox
        id={`grade-${filterKey}`}
        label="Color"
        onChange={onChange}
        checked={isSelected}
      >
        <React.Fragment key={filterKey}>
          {Boolean(iconColor) &&
            iconColor !== "multi-colour" &&
            iconColor !== "unknown" &&
            iconColor !== "white" && (
              <Label
                m="0"
                data-testid={`${iconColor}-circle`}
                variant="circle"
                backgroundColor={iconColor}
                label={iconText}
                fontSize={13}
              />
            )}
          {Boolean(iconColor) && iconColor === "multi-colour" && (
            <MulticolourCircle data-testid="multi-colour-circle" />
          )}
          {Boolean(iconColor) && iconColor === "unknown" && (
            <UnknownCircle data-testid="unknown-circle" />
          )}
          {Boolean(iconColor) && iconColor === "white" && (
            <WhiteCircle data-testid="white-circle" />
          )}
          <Typography
            m="0"
            ml={Boolean(iconColor) ? 2 : 0}
          >{`${filterKey}`}</Typography>
        </React.Fragment>
      </Checkbox>
      <Count number={count} variant="default" />
    </Box>
  );
};

export default CheckboxWithBadge;
